/*       */

export default `
    id
    name
    type
    image
    createdDate
    iconName
    iconColor
    iconType
    primary
    description
    primaryClass {
        entityAppearance
        openInModule
        entityTabs
        formDefinition
        parents {
            formDefinition
        }
        digitalTwins {
            name
        }
    }
    relations {
      entity {
        id
        name
      }
      relatedEntity {
        id
        name
      }
      relation {
        id
        relationDefinition {
          id
          description
          relatedDescription
          classes {
            id
            name
          }
        }
        attributes
        
      }
    }
    primary
    classes {
        id
        name
        uri
        color
    }
    attributes
    relations {
        isReverseRelation
    }
    workspaces {
      isSystem
      team { id }
      user { id }
    }
    active
    modifiedDate
    modifiedBy {
        id
        name
        image
        username
    }
    createdBy {
        id
        name
        image
        username
    }
    createdDate
`;
